import { useSciDomain } from 'components';

import { LoaderRenderer } from './LoaderRenderer';

export const Loader = () => {
  const { data: { loader: loaderImg } = {} } = useSciDomain();

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-flex-1 tw-bg-layout">
      <LoaderRenderer loaderUrl={loaderImg} />
    </div>
  );
};
